module.exports = __webpack_public_path__ + "img/01-min.488ee1fa.jpg";